import { Box, Button, Divider, Paper, Stack, Typography } from "@mui/material";
import { PendingActions, Refresh } from "@mui/icons-material";

import React from "react";

interface ActionToolbarProps {
  lastRefreshed: Date;
  handleRefresh: () => void;
}

const ActionToolbar: React.FC<ActionToolbarProps> = ({
  lastRefreshed,
  handleRefresh,
}) => {
  return (
    <Paper
      elevation={1}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        py: 1.5,
        px: 2,
        borderRadius: 1,
        mb: 2,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <PendingActions color="primary" fontSize="small" />
        <Typography variant="subtitle2" color="primary" fontWeight={600}>
          Actions
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ height: 20, mx: 1 }} />
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="caption" color="text.secondary" mr={1}>
            Last updated:
          </Typography>
          <Typography variant="caption" fontWeight="medium">
            {lastRefreshed.toLocaleTimeString()}
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={2}>
        <Button
          data-testid="aa-act-btn-refresh"
          data-attr="assistant-actions:btn:refresh-actions"
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Refresh fontSize="small" />}
          onClick={handleRefresh}
          sx={{
            borderRadius: 1,
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          Refresh
        </Button>
      </Stack>
    </Paper>
  );
};

export default ActionToolbar;
